import { useEffect } from 'react';
import { useCookies } from 'react-cookie';
import Logger from 'js-logger';
import useLogin from './useLogin';

/**
 * Hook that checks authentication status on mount and clears current user
 * if not authenticated. Also signs out Google if gapi is available.
 * This effect only runs once on mount (matching original behavior).
 */
const useAuthCheck = () => {
  const { clearCurrentUser } = useLogin();
  // eslint-disable-next-line no-unused-vars
  const [cookies] = useCookies();

  useEffect(() => {
    const isAuthenticatedv3 = cookies.v2token !== undefined && cookies.v2token !== '0'
      && cookies.accessToken !== undefined && cookies.accessToken !== '0'
      && cookies.session_id !== undefined && cookies.session_id !== '0'
      && cookies.session_key !== undefined && cookies.session_key !== '0';

    if (!isAuthenticatedv3) {
      clearCurrentUser();
      if (window.gapi) {
        const auth2 = window.gapi.auth2.getAuthInstance();
        if (auth2 !== null) {
          auth2.signOut().then(
            Logger.debug('Google has been signed out'),
          );
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};

export default useAuthCheck;
